import {
  Button,
  Card,
  Heading,
  Input,
  PasswordInput,
  Text,
  ThemeToggle,
} from "@microbeta/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAlternateEmail, MdLockOutline } from "react-icons/md";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { paths } from "../../../../shared/utils/routing";
import { useAuthContext } from "../../AuthContext";
import background from "../../assets/images/background.svg";
import { RecaptchaNotice } from "../../components/RecaptchaNotice";
import styles from "./signin-with-email.module.scss";

const SignInWithEmail = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showVerificationInfo, setShowVerificationInfo] = useState(false);
  const { signInWithEmail, authState } = useAuthContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");

  useEffect(() => {
    if (authState.idToken) {
      if (authState.emailVerified === false) {
        setShowVerificationInfo(true);
      } else {
        console.log(
          `SignInWithEmailPage: user authenticated, navigating to: ${
            redirectUrl || paths.index
          }`
        );
        navigate(redirectUrl || paths.index);
      }
    }
  }, [authState, navigate, redirectUrl]);

  const handleSubmit = async () => {
    try {
      await signInWithEmail(email, password);
    } catch (e) {
      console.error("Unsuccessful signin", e);
    }
  };

  return (
    <div className={styles.container}>
      <img src={background} alt="background" className={styles.backgroundImg} />

      {/* Theme Toggle - positioned in top-right corner */}
      <div className={styles.themeToggleContainer}>
        <ThemeToggle size="md" />
      </div>

      <Card className={styles.card}>
        <Heading variant="medium" className={styles.title}>
          {t("signIn.microbeta")}
        </Heading>

        {showVerificationInfo && (
          <div className={styles.verificationMessage}>
            <Text variant="small">{t("signIn.emailNotVerified")}</Text>
          </div>
        )}

        <Input
          inputContainerClassName={styles.input}
          value={email}
          type="email"
          placeholder={t("signIn.email")}
          label={t("signIn.email")}
          leftComponent={<MdAlternateEmail />}
          onChange={(e) => setEmail(e.currentTarget.value)}
        />
        <PasswordInput
          inputContainerClassName={styles.input}
          value={password}
          placeholder={t("signIn.password")}
          label={t("signIn.password")}
          onChange={(e) => setPassword(e.currentTarget.value)}
          leftComponent={<MdLockOutline />}
        />
        <Button
          variant="primary"
          size="small"
          className={styles.signInButton}
          type="submit"
          onClick={handleSubmit}
        >
          {t("signIn.signInButton")}
        </Button>
        <Link to={paths.requestResetPassword}>
          <Text variant="small" className={styles.forgotPasswordLink}>
            {t("signIn.forgotPassword")}
          </Text>
        </Link>
        <RecaptchaNotice />
      </Card>
    </div>
  );
};

export default SignInWithEmail;
